import React from "react"
import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { Typography } from "@mui/material"
import styles from "./ContestTable.module.scss"
import { styled } from "@mui/system"
import ContestRow from "./ContestRow"
import TableNoRecords from "components/TableNoRecords"

const StyledTable = styled(Table)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  "& .MuiTableCell-root": {
    padding: "14px 24px 12px 0px",
    backgroundColor: theme.palette.background.main,
    borderBottom: `2px solid ${theme.palette.background.default}`,
    boxSizing: "border-box",
    "&:first-of-type": {
      paddingLeft: 6,
      paddingRight: 27
    },
    "&:last-child": {
      paddingRight: 0
    }
  },

  "& .MuiTableCell-head": {
    verticalAlign: "bottom",
    position: "relative",
    "&:last-child": {
      paddingRight: 0
    }
  }
}))

const ContestTable = ({
  weeklyChallengeList,
  isLoading,
  enableRepeatActions = false,
  onRepeatSuccess,
  previousWeeklyChallengeList = []
}) => {
  const challengeOptions = React.useMemo(() => {
    if (!enableRepeatActions) return []
    return [...(weeklyChallengeList ?? []), ...(previousWeeklyChallengeList ?? [])]
  }, [weeklyChallengeList, previousWeeklyChallengeList, enableRepeatActions])

  return (
    <>
      <Paper className={styles.container}>
        <TableContainer sx={{ maxHeight: 600 }}>
          <StyledTable stickyHeader aria-label="contest table">
            <TableHead>
              <TableRow>
                {ContestColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, width: column.maxWidth }}>
                    <Typography className={styles.header} variant="body2Regular">
                      {column.label}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {weeklyChallengeList?.length ? (
                <>
                  {weeklyChallengeList?.map((row) => {
                    return (
                      <ContestRow
                        key={row.id}
                        row={row}
                        columns={ContestColumns}
                        enableRepeatActions={enableRepeatActions}
                        challengeOptions={challengeOptions}
                        onRepeatSuccess={onRepeatSuccess}
                      />
                    )
                  })}
                </>
              ) : (
                <TableNoRecords
                  colSpan={9}
                  label={
                    isLoading ? "Please wait, we are fetching the contests..." : "No Contests Found"
                  }
                />
              )}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </Paper>
    </>
  )
}

export default ContestTable

const ContestColumns = [
  {
    id: "Name",
    label: "Name",
    align: "left",
    minWidth: 80,
    maxWidth: 300
  },

  {
    id: "Weekly Published",
    label: "Weekly Published",
    align: "center",
    minWidth: 80,
    maxWidth: 100
  },
  {
    id: "Created",
    label: "Created",
    align: "center",
    minWidth: 80,
    maxWidth: 100
  },
  {
    id: "Status",
    label: "Status",
    align: "center",
    minWidth: 80,
    maxWidth: 100
  },
  {
    id: "Actions",
    label: "Actions",
    align: "center",
    minWidth: 50,
    maxWidth: 50
  }
]
